function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * This file contains the initialization of the switcher functionality for the location prompt.
 * It fetches the location prompt and select elements, and handles the opening and closing of the prompt.
 * It also handles the click events for choosing a new location and confirming the selection.
 * @module switcher
 */
import Cookies from 'js-cookie';
import NiceSelect from "nice-select2";
import { toggle_loader, disable_loader } from './loader.js';
document.addEventListener("DOMContentLoaded", function () {
  return init_switcher();
}, false);
/**
 * Initializes the switcher functionality for the location prompt.
 * @async
 * @function init_switcher
 * @returns {void}
 */

function init_switcher() {
  return _init_switcher.apply(this, arguments);
}

function _init_switcher() {
  _init_switcher = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var debounce, parent, list, prompt, prompt_select, location_switcher, set_locale, detected_locale, xmlHttp, nice_select, open_prompt, switch_location, open_switcher, close_switcher;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            close_switcher = function _close_switcher() {
              parent.classList.remove('active');
              location_switcher.classList.remove('switcher-active');
              list.style.height = '';
            };

            open_switcher = function _open_switcher() {
              parent.classList.add('active');
              location_switcher.classList.add('switcher-active');
              list.getElementsByTagName('a')[0].focus();
              var anim_height = list.offsetHeight + 54 + 'px';
              list.style.height = '0px';
              setTimeout(function () {
                list.style.height = anim_height;
              }, 5);
            };

            switch_location = function _switch_location(locale) {
              var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              //bring up our loader to prevent any further clicks
              toggle_loader(); //set our locale cookie

              Cookies.set('locale', locale, {
                expires: 30,
                path: '/'
              }); //attempt to find all potential data locales

              var locales = document.querySelectorAll('[data-locale]'); //if we have some locales

              if (locales) {
                //create a temp array
                var temp = []; //loop through eaach locale

                for (var i = 0; i < locales.length; i++) {
                  //push this locale to the temp array (ensures no duplicates)
                  temp.push(locales[i].getAttribute('data-locale').toLowerCase());
                } //swap the locales array for the temp array


                locales = temp;
              } //set our target path


              var target_path = window.location.pathname; //if we have some locales

              if (locales) {
                //loop over our locales
                for (var _i = 0; _i < locales.length; _i++) {
                  //if the target path includes this locale
                  if (target_path.includes(locales[_i])) {
                    //filter out our locale from the target path
                    target_path = target_path.replace(locales[_i] + '/', '');
                  }
                }
              } //if we don't have a url


              if (!url) {
                //build up a url based on our hostname
                url = window.location.protocol + '//' + window.location.hostname + locale.toLowerCase();
              } //create our target destination


              var target_url = url + target_path; //if we have everything we need to redirect

              if (locale && target_url) {
                //make a fetch request to the target page
                fetch(target_url).then(function (response) {
                  //if we have a response and it's valid (aka the page exists on the translated site)
                  if (response && response.status == 200) {
                    //redirect us there
                    window.location.href = target_url;
                  } else {
                    //otherwise, the page doesn't exist
                    //redirect us to the homepage of the new site
                    window.location.href = url;
                  }
                }).catch(function (err) {
                  //if something goes wrong
                  //redirect us to the homepage of the new site
                  window.location.href = url;
                });
              } else {
                //do a simple reload
                location.reload();
              }
            };

            open_prompt = function _open_prompt() {
              var country_code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var location_switcher_text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var confirm_button_text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              //wait a few ms for this to complete
              setTimeout(function () {
                //if we can target the select
                if (prompt_select) {
                  //if we've been passed a country code
                  if (country_code && document.querySelector('#location-prompt-select option[value="' + country_code + '"]')) {
                    //set the prompt to this locale
                    prompt_select.value = country_code; //attempt to target our prompt select element

                    var prompt_select_elem = document.querySelector('label[for="location-prompt-select"]'); //attempt to target our prompt button element

                    var button_elem = document.getElementById('location-prompt-confirm'); //if we have a prompt select element and we've been passed some text for it

                    if (prompt_select_elem && location_switcher_text) {
                      //override our prompt text with regional text
                      prompt_select_elem.innerHTML = location_switcher_text;
                    } //if we have a button element and we've been passed some text for it


                    if (button_elem && confirm_button_text) {
                      //override our prompt text with regional text
                      button_elem.innerHTML = confirm_button_text;
                    }
                  } else {
                    //otherwise we have no idea where the user is
                    //set the prompt to the default locale (GB)
                    prompt_select.value = 'GB';
                  } //update the detected locale cookie


                  Cookies.set('locale_detected', JSON.stringify({
                    country_code: country_code,
                    location_switcher_text: location_switcher_text,
                    confirm_button_text: confirm_button_text
                  }), {
                    expires: 30,
                    path: '/'
                  }); //unhide it

                  prompt.classList.remove('hidden'); //move us to the top of the page

                  window.scrollTo(0, 0); //grab its height

                  var prompt_height = prompt.offsetHeight; //use the height to make it go off screen

                  prompt.style.marginBottom = '-' + prompt_height + 'px'; //wait a few ms for this to complete

                  setTimeout(function () {
                    //reveal the prompt
                    prompt.classList.add('active');
                  }, 100);
                } //trigger a change event


                var event = new Event('change');
                prompt_select.dispatchEvent(event);
              }, 250);
            };

            //require our debounce library for later
            debounce = require('debounce'); // Subdomain redirect logic

            parent = false;
            list = false; //fetch our location prompt (if it exists)

            prompt = document.getElementById('location-prompt'); //fetch our location prompt select (if it exists)

            prompt_select = document.getElementById('location-prompt-select'); //fetch our bottom location switcher (if it exists)

            location_switcher = document.getElementById('location-container'); //if we have a prompt

            if (prompt) {
              //attempt to fetch locally stored detected locale
              set_locale = Cookies.get('locale'); //attempt to fetch our detected locale cookie (to save API requests)

              detected_locale = Cookies.get('locale_detected'); //if we don't have a chosen location

              if (!set_locale) {
                //if we've stored a detected locale and it's JSON, use it
                if (typeof detected_locale != 'undefined' && detected_locale.includes('{') && detected_locale.includes('}')) {
                  //parse our detected locale
                  detected_locale = JSON.parse(detected_locale); //open the prompt with our JSON values

                  open_prompt(detected_locale.country_code ? detected_locale.country_code : false, detected_locale.location_switcher_text ? detected_locale.location_switcher_text : false, detected_locale.confirm_button_text ? detected_locale.confirm_button_text : false);
                } else {
                  //build a request
                  xmlHttp = new XMLHttpRequest(); //on success, trigget this function

                  xmlHttp.onreadystatechange = function () {
                    //if we have a response and it's valid
                    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                      //parse the response data
                      var response_json = JSON.parse(xmlHttp.responseText); //attempt to get the country code

                      var country_code = response_json.countryCode; //fetch our updated labels

                      var location_switcher_text = response_json.location_switcher_text;
                      var confirm_button_text = response_json.confirm_button_text; //open the prompt

                      open_prompt(country_code ? country_code : false, location_switcher_text, confirm_button_text);
                    }
                  }; // //set the request url to the reverse geolocation service


                  xmlHttp.open("GET", document.body.dataset.json + 'get_country', true); // true for asynchronous
                  //make request

                  xmlHttp.send();
                }
              }
              /**
               * Click handler for when a new location is chosen and confirmed in the prompt
               */


              document.addEventListener('click', function (event) {
                // If the clicked element isn't a data-locale element
                if (!event.target.matches('#location-prompt-confirm')) return; //prevent the default action

                event.preventDefault(); //grab the selected option

                var url = document.querySelector('#location-prompt-select option[value="' + prompt_select.value + '"]'); //if we have a valid element and it has a data-url attribute

                if (url && url.dataset.url) {
                  //swap the url for the data-url
                  url = url.dataset.url;
                } //switch our location


                switch_location(prompt_select.value, url);
              }); //listen for changes on the prompt select

              prompt_select.addEventListener('change', function (event) {
                //grab the current value
                var current = event.target.value; //find the nice select target...

                var nice_select_target = document.querySelector('#location-prompt-select + .nice-select .current'); //if we have a nice select target

                if (nice_select_target) {
                  //set the data value to the current value (this allows our icon to load)
                  nice_select_target.dataset.value = current; //set the inner text to the current value

                  nice_select_target.innerHTML = event.target.options[event.target.selectedIndex].text;
                }
              }); //initialize our nice select

              nice_select = new NiceSelect(document.getElementById('location-prompt-select'));
            } //if we have a location switcher


            if (location_switcher) {
              /**
               * Click handler for the footer location switcher
               */
              document.addEventListener('click', function (event) {
                // If the clicked element doesn't have the right selector, bail
                if (!event.target.matches('#choose-location')) return; //target the parent element to add the active class

                parent = event.target.parentNode; //target the list in order to smoothly animate its height

                list = event.target.nextElementSibling; //if the parent is already active

                if (parent.classList.contains('active')) {
                  //close the switcher (as we know it's open)
                  close_switcher();
                } else {
                  //otherwise...
                  //open the switcher
                  open_switcher();
                }
              }, false);
              /**
               * On resize, close the switcher if it's open as this can cause responsiveness issues.
               */

              window.addEventListener('resize', debounce(function (e) {
                if (parent && parent.classList.contains('active')) {
                  close_switcher();
                }
              }, 200));
            }
            /**
             * Handles opening the location prompt
             */


          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _init_switcher.apply(this, arguments);
}